var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#747474",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.33333H24C24.8755 9.33333 25.7424 9.50577 26.5512 9.8408C27.36 10.1758 28.095 10.6669 28.714 11.286C29.3331 11.905 29.8241 12.6399 30.1592 13.4488C30.4942 14.2576 30.6666 15.1245 30.6666 16C30.6666 16.8755 30.4942 17.7424 30.1592 18.5512C29.8241 19.3601 29.3331 20.095 28.714 20.714C28.095 21.3331 27.36 21.8242 26.5512 22.1592C25.7424 22.4942 24.8755 22.6667 24 22.6667H20M12 22.6667H7.99998C7.1245 22.6667 6.25759 22.4942 5.44876 22.1592C4.63992 21.8242 3.90499 21.3331 3.28593 20.714C2.03569 19.4638 1.33331 17.7681 1.33331 16C1.33331 14.2319 2.03569 12.5362 3.28593 11.286C4.53618 10.0357 6.23187 9.33333 7.99998 9.33333H12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16H21.3334",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.424ba8adf8501bea24d531e63aadb836.svg";
export { ForwardRef as ReactComponent };